import { DOCUMENT } from '@angular/common';
import { Subject, fromEvent, of } from 'rxjs';
import { takeUntil, switchMap, debounceTime, combineLatest, startWith } from 'rxjs/operators';
import { Injectable, NgModule, Component, ViewChild, Input, Directive, Output, EventEmitter, Inject, Renderer2, defineInjectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const DefinedSensitivity = {
    Locked: 10000,
    veryLow: 50,
    Low: 40,
    Medium: 30,
    High: 20,
    veryHigh: 10,
};
DefinedSensitivity[DefinedSensitivity.Locked] = 'Locked';
DefinedSensitivity[DefinedSensitivity.veryLow] = 'veryLow';
DefinedSensitivity[DefinedSensitivity.Low] = 'Low';
DefinedSensitivity[DefinedSensitivity.Medium] = 'Medium';
DefinedSensitivity[DefinedSensitivity.High] = 'High';
DefinedSensitivity[DefinedSensitivity.veryHigh] = 'veryHigh';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const NavbarState = {
    SHOW: 'show',
    HIDE: 'hide',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const SpacerTypes = {
    MARGIN: 'margin-top',
    PADDING: 'padding-top',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxStickyNavbarService {
    constructor() {
        this.changeSettings$ = new Subject();
        this.initialSettings = {
            spacer: { autoHeight: false, height: 0 },
            sensitivity: { top: DefinedSensitivity.veryLow, bottom: DefinedSensitivity.veryHigh },
            scroll: { offset: { autoTop: false, top: 300 } }
        };
        this.settings = this.initialSettings;
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    setGlobalSettings(settings) {
        this.settings = this._parseNewSettingsObject(this.settings, settings);
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    mergeSettingObject(settings) {
        this.setGlobalSettings(settings);
        this.changeSettings$.next(this.settings);
    }
    /**
     * @private
     * @param {?} oldSets
     * @param {?} newSets
     * @return {?}
     */
    _parseNewSettingsObject(oldSets, newSets) {
        /** @type {?} */
        let sets = Object.assign({}, oldSets, newSets);
        if (!!newSets.spacer) {
            sets = Object.assign({}, sets, this._setSpace(oldSets, newSets));
        }
        if (!!newSets.sensitivity) {
            sets = Object.assign({}, sets, this._setSensitivity(oldSets, newSets));
        }
        if (!!newSets.scroll) {
            sets = Object.assign({}, sets, this._setScroll(oldSets, newSets));
        }
        return sets;
    }
    /**
     * @private
     * @param {?} oldSets
     * @param {?} newSets
     * @return {?}
     */
    _setSpace(oldSets, newSets) {
        return {
            spacer: Object.assign({}, oldSets.spacer, newSets.spacer)
        };
    }
    /**
     * @private
     * @param {?} oldSets
     * @param {?} newSets
     * @return {?}
     */
    _setSensitivity(oldSets, newSets) {
        return {
            sensitivity: Object.assign({}, oldSets.sensitivity, newSets.sensitivity)
        };
    }
    /**
     * @private
     * @param {?} oldSets
     * @param {?} newSets
     * @return {?}
     */
    _setScroll(oldSets, newSets) {
        return {
            scroll: Object.assign({}, oldSets.scroll, newSets.scroll, { offset: Object.assign({}, oldSets.scroll.offset, newSets.scroll.offset) })
        };
    }
}
NgxStickyNavbarService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ NgxStickyNavbarService.ngInjectableDef = defineInjectable({ factory: function NgxStickyNavbarService_Factory() { return new NgxStickyNavbarService(); }, token: NgxStickyNavbarService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxStickyNavbarDirective {
    /**
     * @param {?} document
     * @param {?} navbarService
     * @param {?} renderer
     */
    constructor(document, navbarService, renderer) {
        this.document = document;
        this.navbarService = navbarService;
        this.renderer = renderer;
        this.isScrollDetected = new EventEmitter();
        this._scrollableElement = this.document.body;
        this._previousScroll = 0;
        this._scrollTop = 0;
        this._destroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.navbarService.changeSettings$.pipe(takeUntil(this._destroy$), switchMap((/**
         * @param {?} _
         * @return {?}
         */
        _ => {
            this._defineScrollableElement();
            if (!!this.navbarService.settings.spacer.element) {
                this._showSpacer();
            }
            return fromEvent(this._scrollableElement, 'scroll');
        }))).subscribe((/**
         * @param {?} _
         * @return {?}
         */
        _ => {
            this._scrollTop = this._scrollableElement.scrollTop;
            this._isScrolledToTopWithOffset();
            this._speedScrollDetection();
            this._previousScroll = this._scrollTop;
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    /**
     * @private
     * @return {?}
     */
    _showSpacer() {
        if (this._settings.spacer.type !== undefined && this._settings.spacer.height !== undefined) {
            this._spacerCreator(this._settings.spacer.element, this._settings.spacer.type, this._settings.spacer.height);
        }
        else {
            console.error('[ERROR] Spacer requires type and height definitions. One or both of those defs are not provided!');
        }
    }
    /**
     * @private
     * @return {?}
     */
    _defineScrollableElement() {
        if (!!this._settings.scroll.element) {
            /** @type {?} */
            const element = this.document.querySelector(this._settings.scroll.element);
            if (!!element) {
                this._scrollableElement = element;
            }
        }
    }
    /**
     * @private
     * @param {?} element
     * @param {?} type
     * @param {?} height
     * @return {?}
     */
    _spacerCreator(element, type, height) {
        this.renderer.setProperty(element.nativeElement, 'style', `${type}:${height}px`);
    }
    /**
     * @private
     * @return {?}
     */
    _isScrolledToTopWithOffset() {
        if (this._scrollTop <= this._settings.scroll.offset.top && this._isScrollingTop) {
            this.isScrollDetected.next(NavbarState.SHOW);
        }
    }
    /**
     * @private
     * @return {?}
     */
    _speedScrollDetection() {
        if (this._scrollTop + this._senseSpeedTop < this._previousScroll) {
            this.isScrollDetected.next(NavbarState.SHOW);
        }
        else if (this._scrollTop - this._senseSpeedBottom > this._previousScroll) {
            this.isScrollDetected.next(NavbarState.HIDE);
        }
    }
    /**
     * @private
     * @return {?}
     */
    get _settings() {
        return this.navbarService.settings;
    }
    /**
     * @private
     * @return {?}
     */
    get _senseSpeedTop() {
        /** @type {?} */
        let speedSenseTop = 0;
        if (typeof this._settings.sensitivity.top === 'string') {
            speedSenseTop = DefinedSensitivity[this._settings.sensitivity.top];
        }
        else {
            speedSenseTop = this._settings.sensitivity.top;
        }
        return speedSenseTop;
    }
    /**
     * @private
     * @return {?}
     */
    get _senseSpeedBottom() {
        /** @type {?} */
        let speedSenseBottom = 0;
        if (typeof this._settings.sensitivity.bottom === 'string') {
            speedSenseBottom = DefinedSensitivity[this._settings.sensitivity.bottom];
        }
        else {
            speedSenseBottom = this._settings.sensitivity.bottom;
        }
        return speedSenseBottom;
    }
    /**
     * @private
     * @return {?}
     */
    get _isScrollingTop() {
        return this._scrollTop < this._previousScroll;
    }
}
NgxStickyNavbarDirective.decorators = [
    { type: Directive, args: [{ selector: '[ngxSpeedScroll]' },] }
];
/** @nocollapse */
NgxStickyNavbarDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: NgxStickyNavbarService },
    { type: Renderer2 }
];
NgxStickyNavbarDirective.propDecorators = {
    isScrollDetected: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxStickyNavbarComponent {
    /**
     * @param {?} navbarService
     */
    constructor(navbarService) {
        this.navbarService = navbarService;
        this.navbarState = NavbarState;
        this.isNavbarState = NavbarState.SHOW;
        this._destroy$ = new Subject();
    }
    /**
     * @private
     * @return {?}
     */
    get _settings() {
        return this.navbarService.settings;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.navbarService.changeSettings$.pipe(takeUntil(this._destroy$), switchMap((/**
         * @param {?} settings
         * @return {?}
         */
        (settings) => {
            this._createSettingsObject();
            return of(settings).pipe(combineLatest(this._resizeEvent));
        })), startWith([this.settings, new Event('resize')])).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        ([settings, _]) => this.navbarService.mergeSettingObject(settings)));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this._settings.spacer.autoHeight) {
            /** @type {?} */
            const settings = Object.assign({}, this._settings, { spacer: Object.assign({}, this._settings.spacer, { height: this._elementSpacerHeight }) });
            this.navbarService.setGlobalSettings(settings);
        }
        this.navbarService.mergeSettingObject(this.settings);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    /**
     * @param {?} state
     * @return {?}
     */
    onScrollDetected(state) {
        this.isNavbarState = state;
    }
    /**
     * @private
     * @return {?}
     */
    _createSettingsObject() {
        /** @type {?} */
        let settings = {};
        if (this._settings.spacer.autoHeight) {
            settings = Object.assign({}, this._settings, { spacer: Object.assign({}, this._settings.spacer, { height: this._elementSpacerHeight }) });
        }
        if (this._settings.scroll.offset.autoTop) {
            settings = Object.assign({}, this._settings, settings, { scroll: Object.assign({}, this._settings.scroll, { offset: Object.assign({}, this._settings.scroll.offset, { top: this._elementOffsetTopHeight }) }) });
        }
        this.navbarService.setGlobalSettings(settings);
    }
    /**
     * @private
     * @return {?}
     */
    get _resizeEvent() {
        return fromEvent(window, 'resize')
            .pipe(debounceTime(100));
    }
    /**
     * @private
     * @return {?}
     */
    get _elementOffsetTopHeight() {
        if (this._settings.scroll.offset.autoTop) {
            return this.navbar.nativeElement.offsetHeight;
        }
        else {
            return this._settings.scroll.offset.top;
        }
    }
    /**
     * @private
     * @return {?}
     */
    get _elementSpacerHeight() {
        if (this._settings.spacer.autoHeight) {
            return this.navbar.nativeElement.offsetHeight;
        }
        else {
            return this._settings.spacer.height;
        }
    }
}
NgxStickyNavbarComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-sticky-navbar',
                template: "<div class=\"ngx-speed-scroll\"\r\n     ngxSpeedScroll\r\n     #navbar\r\n     [ngClass]=\"{'ngx-speed-scroll_hidden': isNavbarState === navbarState.HIDE}\"\r\n     (isScrollDetected)=\"onScrollDetected($event)\">\r\n    <ng-content></ng-content>\r\n</div>\r\n",
                styles: [".ngx-speed-scroll{position:fixed;top:0;left:0;width:100%;transition:top .3s}.ngx-speed-scroll_hidden{top:-100%;transition:top 1s}"]
            }] }
];
/** @nocollapse */
NgxStickyNavbarComponent.ctorParameters = () => [
    { type: NgxStickyNavbarService }
];
NgxStickyNavbarComponent.propDecorators = {
    settings: [{ type: Input }],
    navbar: [{ type: ViewChild, args: ['navbar',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxStickyNavbarModule {
}
NgxStickyNavbarModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NgxStickyNavbarDirective, NgxStickyNavbarComponent],
                imports: [BrowserModule],
                exports: [NgxStickyNavbarComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxStickyNavbarService, NgxStickyNavbarDirective, NgxStickyNavbarComponent, NgxStickyNavbarModule, DefinedSensitivity, NavbarState, SpacerTypes };

//# sourceMappingURL=ngx-sticky-navbar.js.map